import { gaPushEvent } from "../base.analytics";

enum Event {
  NOTIFICATION_OPENED = "notification_opened",
  NOTIFICATION_CLICKED = "notification_clicked",
  NOTIFICATION_CENTER_VIEWED = "notification_center_viewed",
}

export function gaEventNotificationOpened(
  notificationId: string,
  userUid: string
) {
  gaPushEvent(Event.NOTIFICATION_OPENED, {
    notification_id: notificationId,
    user: {
      account_id: userUid,
    },
  });
}

export function gaEventNotificationClicked(
  notificationId: string,
  userUid: string
) {
  gaPushEvent(Event.NOTIFICATION_CLICKED, {
    notification_id: notificationId,
    user: {
      account_id: userUid,
    },
  });
}

export function gaEventNotificationCenterViewed(userUid: string) {
  gaPushEvent(Event.NOTIFICATION_CENTER_VIEWED, {
    user: {
      account_id: userUid,
    },
  });
}
